export default __webpack_public_path__ + "static/media/SHARE_CARE.df433486.png";